import Application from '../../Application'
import { IDatabase, IDatabasePayload } from '../client/PGManager'
import Schema from './Schema'

export default class Database {
  private _info?: IDatabase
  // private _schemas?: string[]

  constructor(
    public readonly app: Application,
    public readonly ref: string,
    info?: IDatabase
  ) {
    if (info) {
      this._info = info
    }
  }

  // getters
  get info(): IDatabase | void {
    return this._info
  }

  get schemas(): string[] | void {
    return this._info && this._info.schemas
  }

  // factories
  schema(schema: string): Schema {
    return new Schema(this.app, this.ref, schema)
  }

  // api
  drop(): Promise<this> {
    return this.app
      .client()
      .pgManager.dropDatabase(this.ref)
      .then(() => {
        this._info = undefined

        return this
      })
  }

  create(options: IDatabasePayload): Promise<this> {
    return this.app
      .client()
      .pgManager.createDatabase({
        ...options,
        name: this.ref,
      })
      .then((info) => {
        this._info = info

        return this
      })
  }

  sync(): Promise<this> {
    return this.app
      .client()
      .pgManager.getDatabase(this.ref)
      .then((info) => {
        this._info = info

        return this
      })
  }
}
